import Dataviz from './Dataviz';

export default Dataviz;
